<script setup lang="ts">
import { useHead, storeToRefs } from '#imports';
import Skeleton from 'primevue/skeleton';

import { useDictionariesStore } from '@/entities/Dictionary/store/dictionaries';
import DictionaryCard from '@/entities/Dictionary/components/dictionary-card.vue';

import { MAIN_TITLE } from '@/shared/constant';

const dictionariesStore = useDictionariesStore();
const { selectDictionaryId, currentDictionary: dictionary } = storeToRefs(dictionariesStore);
const { getDictionaryById } = dictionariesStore;

const setDictionary = async (id: number) => {
	selectDictionaryId.value = id;
	dictionary.value = await getDictionaryById(id);
};

useHead({
	titleTemplate: `Главная | ${MAIN_TITLE}`,
});
</script>

<template>
	<section class="section main">
		<div class="main__container container">
			<div class="section__wrapper">
				<h1
					v-if="dictionary?.name"
					class="section__title"
					v-text="dictionary?.name"
				/>
				<skeleton
					v-else
					width="100%"
					height="2rem"
					border-radius="16px"
					class="section__title"
				/>

				<div class="section__content">
					<client-only>
						<ul class="main__list">
							<li v-if="dictionary" class="main__list-item">
								<dictionary-card
									:card="dictionary"
									@change="setDictionary"
								/>
							</li>
							<li v-else class="main__list-item">
								<skeleton
									width="100%"
									height="16rem"
									border-radius="16px"
								/>
							</li>
						</ul>
					</client-only>
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
.main {
	&__list {
		&-item {
			margin-bottom: rem($gap-mini);

			@include reset-indent-last;

			@media #{$screen-laptop} {
				margin-bottom: rem($gap-medium);
			}
		}
	}
}
</style>
